import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
export const useGeneralSettingsQuery = () => {
    const { data, isLoading } = useCachedSWR(PUBLIC_SWR_KEYS.GENERAL_SETTINGS);
    return { generalSettings: data === null || data === void 0 ? void 0 : data.generalSettings, isLoading };
};
